

export class FuelTypeUpdateInput implements IFuelTypeUpdateInput {
    /** The auto-generated id of the fuel type master */
    fuelTypeId!: number;
    /** The fuel type name with 255 character limit */
    fuelTypeName!: string;

    constructor(data?: IFuelTypeUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelTypeId = _data["fuelTypeId"];
            this.fuelTypeName = _data["fuelTypeName"];
        }
    }

    static fromJS(data: any): FuelTypeUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelTypeUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelTypeId"] = this.fuelTypeId;
        data["fuelTypeName"] = this.fuelTypeName;
        return data; 
    }
}

export interface IFuelTypeUpdateInput {
    /** The auto-generated id of the fuel type master */
    fuelTypeId: number;
    /** The fuel type name with 255 character limit */
    fuelTypeName: string;
}

